var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table"},[_c('date-t-head',{attrs:{"value":_vm.value}}),_vm._v(" "),_c('date-t-body',{attrs:{"value":_vm.value,"selectedValue":_vm.selectedValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }